import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { fullName, hasPermission } from "../../utils/helper";
import { PERMISSION } from "../../utils/constants";
import CourierListPage, { CourierListHeadAction } from "./courier-list-page";
import CreateCourierForm from "./forms/create-courier-form";
import EditCourierForm from "./forms/edit-courier-form";
import CourierTable from "./ui/courier-table";
import CourierBooleanTag from "./ui/courier-boolean-tag";
import RowActions from "./ui/row-actions";
import { useCourierMutationDone } from "./ui/use-courier-mutation-done";

const CouriersList = props => {
  const {
    getCouriers,
    getCourierZones,
    couriers = [],
    zones = [],
    courierLoading,
    courierApiError,
    createCourier,
    updateCourier,
    resetCourierState
  } = props;

  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const canManage = hasPermission(PERMISSION.CAN_MANAGE_COURIERS);

  useCourierMutationDone(courierLoading, courierApiError, () => {
    setIsOpenCreateModal(false);
    setEditTarget(null);
  });

  useEffect(() => {
    getCouriers({});
    getCourierZones && getCourierZones({});
    return () => {
      resetCourierState();
    };
  }, []);

  return (
    <CourierListPage
      title="Couriers"
      count={couriers.length}
      loading={courierLoading}
      headActions={
        canManage && (
          <CourierListHeadAction
            label="Add Courier"
            onClick={() => setIsOpenCreateModal(true)}
          />
        )
      }
    >
      <CourierTable>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Zones</th>
            <th className="status">Active</th>
            <th className="status">On Duty</th>
            {canManage && <th className="act">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {couriers.map(c => (
            <tr key={c.id}>
              <td>
                {c.fullName || fullName(c)}
                <span className="sm-text">ID {c.id}</span>
              </td>
              <td>{c.phone}</td>
              <td>{(c.zones || []).map(z => z.name).join(", ") || "—"}</td>
              <td className="status">
                <CourierBooleanTag value={c.isActive} />
              </td>
              <td className="status">
                <CourierBooleanTag value={c.isOnDuty} />
              </td>
              {canManage && (
                <td className="act">
                  <RowActions onEdit={() => setEditTarget(c)} />
                </td>
              )}
            </tr>
          ))}
          {!couriers.length && !courierLoading && (
            <tr>
              <td colSpan={canManage ? 6 : 5}>No couriers found.</td>
            </tr>
          )}
        </tbody>
      </CourierTable>

      {isOpenCreateModal && (
        <Modal
          isOpen={isOpenCreateModal}
          onRequestClose={() => setIsOpenCreateModal(false)}
          className="small-modal"
        >
          <CreateCourierForm
            closeModal={() => setIsOpenCreateModal(false)}
            loading={courierLoading}
            apiError={courierApiError}
            createCourier={createCourier}
          />
        </Modal>
      )}

      {editTarget && (
        <Modal
          isOpen={!!editTarget}
          onRequestClose={() => setEditTarget(null)}
          className="small-modal"
        >
          <EditCourierForm
            courier={editTarget}
            zones={zones}
            closeModal={() => setEditTarget(null)}
            loading={courierLoading}
            apiError={courierApiError}
            updateCourier={updateCourier}
          />
        </Modal>
      )}
    </CourierListPage>
  );
};

export default CouriersList;
